/* eslint-disable react/jsx-key */

import IconLetters from '../icons/IconLetters.jsx'

export default [
    [
        'TARGET',
        'SOP',

        <IconLetters
            fill="#fff"
            letters="O"
            textColor="#000"
        />
    ],

    [
        'TARGET2',
        '端到端',

        <IconLetters
            fill="#fff"
            letters="E"
            textColor="#000"
        />
    ],
]
